import $ from 'jquery';

/**
 * profile section representative cases
 *
 * @module profile-rep-cases
 * @version 0.1.1
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-21 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 using ChatGPT on 2023-12-12
 */

class ProfileRepCases {
  constructor(element) {
    this.$el = $(element);
    this.setupDefaults();
    this.setBinds();
  }

  setupDefaults() {
    this.$menuItem = this.$el.find('.left-menu-item');
    this.$rightItem = this.$el.find('.right-item');
    this.$expandBtn = this.$el.find('.expand');
  }

  setBinds() {
    //this.$menuItem.on('click', (evt) => this.handleMenuItemClick(evt));
    this.$expandBtn.on('click', (e) => this.handleExpandClick(e));
  }

  handleMenuItemClick(evt) {
    let clicked = $(evt.currentTarget);
    let clickedIndex = clicked.index();

    if (!clicked.hasClass('active')) {
      this.$menuItem.removeClass('active');
      clicked.addClass('active');
    }

    if (this.$rightItem.hasClass('active')) {
      this.$rightItem.removeClass('active');
    }

    this.$rightItem.eq(clickedIndex).addClass('active');
  }

  handleExpandClick(e) {
    let text = this.$expandBtn.text();
    $(e.currentTarget).siblings('.expandContent').slideToggle('fast');
    this.$expandBtn.text(text.includes('Expand All') ? 'Collapse All' : 'Expand All');
  }
}

export default ProfileRepCases;
